/* istanbul ignore file */
import { ReactionType } from 'src/components/postComments/components/commentReaction'
import {
  Like,
  PostCommentProps,
  PostCommentLessonProps
} from 'src/pages/CommunityDetails/Posts/posts.types'
import api from '../services/apiSparkle'
import { CommentOrigin } from './enum'
import { CommentEndpoints } from './comment/constants'
import { GetCommentImageProps } from './types'

export const getComments = async (
  id: number,
  rows: number,
  nextPageToken: string,
  avatarSize: number
) => {
  const nextPage = nextPageToken ? `&nextPageToken=${nextPageToken}` : ''
  const url = `rest/v3/news/${id}/comments?rows=${rows}${nextPage}&avatarDimensions=${avatarSize}x${avatarSize}&withReplies=false`
  const res = await api.get(url)
  return res.data
}

export const getRepliesComments = async (
  id: number,
  commentId: number,
  rows: number,
  nextPageToken: string,
  avatarSize: number,
  sort?: string
  // eslint-disable-next-line max-params
) => {
  const nextPage = nextPageToken ? `&nextPageToken=${nextPageToken}` : ''

  const url = `${CommentEndpoints.getRepliesComments(id, commentId)}?rows=${rows}${nextPage}&avatarDimensions=${avatarSize}x${avatarSize}&sort=${sort}`

  const res = await api.get(url)

  return res.data
}

export const postComment = async (
  id: number,
  postPublication: PostCommentProps,
  creationOrigin: CommentOrigin
) => {
  const body = { ...postPublication, creationOrigin }

  const url = `rest/v2/news/${id}/comments`
  const res = await api.post(url, body)

  return res.data
}

export const deleteComment = async (id: number, commentId: number) => {
  const url = `rest/v1/news/${id}/comments/${commentId}`
  const res = await api.delete(url)
  return res.data
}

export const putLike = async (commentId: number) => {
  const body: Like = {
    reactionType: ReactionType.LIKE
  }

  const url = `rest/v1/comments/${commentId}/reaction`

  const res = await api.put(url, body)
  return res.data
}

export const deleteLike = async (commentId: number) => {
  const url = `rest/v1/comments/${commentId}/reaction`
  const res = await api.delete(url)
  return res.data
}

export const getCommentImage = async ({
  publicationId,
  commentId,
  imageDimension,
  redirect = false,
  isUnauthenticated = false
}: GetCommentImageProps) => {
  const params = {
    redirect,
    dimensions: `${imageDimension.width}x${imageDimension.height}`
  }

  const url = isUnauthenticated
    ? CommentEndpoints.getPublicCommentImage(publicationId, commentId)
    : CommentEndpoints.getCommentImage(publicationId, commentId)

  const { data: commentData } = await api.get<{ data: string }>(`${url}`, {
    params
  })

  return commentData.data
}

export const getCommentAudio = async (commentId: number, redirect = false) => {
  const params = {
    redirect
  }
  const { data: commentData } = await api.get<{ mediaUrl: string }>(
    `${CommentEndpoints.getCommentAudio(commentId)}`,
    {
      params
    }
  )

  return commentData.mediaUrl
}

export const getCommentDocument = async (
  publicationId: number,
  commentId: number,
  redirect = false
) => {
  const params = {
    redirect
  }
  const { data: commentData } = await api.get<{ data: string }>(
    `${CommentEndpoints.getCommentDocument(publicationId, commentId)}`,
    {
      params
    }
  )

  return commentData.data
}

// LESSON ENDPOINTS

export const getCommentsInLesson = async (
  membershipId: string,
  courseId: number,
  lessonHash: string
) => {
  const url = `/rest/v1/membership/${membershipId}/courses/${courseId}/lessons/${lessonHash}/comments/info`
  const res = await api.get(url)
  return res.data
}

export const postCommentLesson = async (body: PostCommentLessonProps) => {
  const url = '/rest/v1/membership/comments'
  const res = await api.post(url, body)
  return res.data
}

export const showCommentReactionsCount = async () => {
  const url = '/rest/v1/users/feature/ENABLE_SHOW_COMMENT_REACTIONS_COUNT'
  const res = await api.get(url)
  return res.data
}
